/**
 * @ken/module-secure_links — the no-login phone page (ADR-0269). Secure links
 * has no screens in the signed-in cockpit in slice S1 (the office side is S3),
 * so its route table is empty. Its one screen is mounted shell-less by the
 * cockpit's own file route, `/l/$secret` (l.$secret.tsx), and downloads only
 * when a link is opened (BND-01).
 */

import { lazyScreen, type CreateModuleRoutes } from "@ken/cockpit-types";

export type { FindLinkPage, SecureLinkScreenProps } from "./routes/screen";

/** The phone page, mounted shell-less (no login) by the cockpit at /l/$secret. */
export const SecureLinkScreen = lazyScreen(() => import("./routes/screen"), "SecureLinkScreen");

export const createRoutes: CreateModuleRoutes = () => [];

/** No module-scoped context: the registry reads `Provider ?? undefined`. */
export const Provider = undefined;
